module.exports = __webpack_public_path__ + "img/harmonyos.fc5f5991.png";